const MODULE_BASE = `${process.env.REACT_APP_PATH_MAP_BASE}/cal-sco/ecommerce`

const ECOMMERCE_PATH = `${MODULE_BASE}/upload`;

const pathMap = {
    //Upload
    UPLOAD_PAGE: ECOMMERCE_PATH,
}

export default pathMap